// TODO PP-16776: move LoggedInWeb/utils/ajax-utils here once we complete webpack LoggedInWeb migration

export * from '../../LoggedInWeb/utils/ajax-utils';
